import Feature from '@js/plugins/feature';
import moment from 'moment';

class Auth {
    canAccessAllOutlets() {
        return this.outlets().length === 0;
    }

    canExtendAccount() {
        return Feature.hasFeature('extend_account');
    }

    hasAnyPermission(...permissions) {
        if (Array.isArray(permissions[0])) {
            permissions = permissions[0];
        }

        for (var permission of permissions) {
            if (this.hasPermissionTo(permission)) {
                return true;
            }
        }

        return false;
    }

    hasPermissionTo(permission) {
        let permissions = _.get(window.slurp, 'auth.user.permissions', []);
        return _.includes(permissions, permission);
    }

    hasSubscription() {
        return true;
    }

    franchise() {
        let franchise = _.get(window.slurp, 'auth.franchise');

        return franchise;
    }

    outlets() {
        return _.get(window.slurp, 'auth.user.outlets', []);
    }

    user() {
        let user = _.get(window.slurp, 'auth.user');
        user.last_login = moment(user.last_login);
        user.last_login_dashboard = moment
            .parseZone(user.last_login_string)
            .local();

        return user;
    }

    metas() {
        let metas = _.get(window.slurp, 'auth.franchise.meta');

        return metas;
    }
}

const AuthInstance = new Auth();

export default AuthInstance;
